import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import WapDatosDeMiEvento from './WapDatosDeMiEvento';
import Header from './components/Header';
import Body from './components/Body';
import EditAdminCelebratedInfo from '../EditAdminCelebratedInfo';
import * as eventDetailsActions from './actions';
import ApplyCSS from '../../../../../components/ApplyCSS';
import commonUtil from '../../../../../utils/commonUtil';
import * as defaultConst from '../../../../../utils/clientConstant';
import { loadGiftRegistryCelebrated } from '../../../../createEvent/components/GiftRegistryCelebrated/actions';
import { strategy } from '../../../../createEvent/createEventStrategy/strategy';

const applicationRoutes = commonUtil.getApplicationRoutes();
const channel = commonUtil.getChannel().toUpperCase();
const { getEventDetails, saveEventName, removeCoOwner, handleSaveEventName, handleValidateEventName } = eventDetailsActions;
// const { strategy } = require('./../strategy');


const pageName = 'eventInfo';

@connect(store => ({
  store,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  {
    ...eventDetailsActions,
  })

class DatosDeMiEvento extends Component {
  state = {
    isAddingAndEditingNewCoOwnerMode: false, // mobile
    isEditMode: false,    // desktop
    celebrityInfo: '',
    isNewCoOwnerAddingMode: false,
    isrender: false,
  }
  eventChange = false
  addNewCoOwner = () => {
    this.setState({
      isNewCoOwnerAddingMode: true,
    });
  }
  showWapEditingSection = () => {
    this.setState({
      isAddingAndEditingNewCoOwnerMode: true,
    });
  }
  handleCancelEditingAndAdding = (mode) => {
    if (channel === 'WEB') {
      this.setState({
        isEditMode: false,
        isAddingAndEditingNewCoOwnerMode: false,
        isNewCoOwnerAddingMode: false,
        celebrityInfo: '',
      });
    } else if (this.state.isAddingAndEditingNewCoOwnerMode) {
      this.setState({
        isAddingAndEditingNewCoOwnerMode: false,
        isNewCoOwnerAddingMode: false,
      });
    } else if (mode === 'addingNewCoOwner') {
      this.setState({
        isEditMode: false,
        isAddingAndEditingNewCoOwnerMode: true,
        isNewCoOwnerAddingMode: true,
        celebrityInfo: '',
      });
    } else if (mode === 'loadNewEvent') {
      this.eventChange = true;
      // this.setState({
      //   isAddingAndEditingNewCoOwnerMode: false, // mobile
      //   isEditMode: false,    // desktop
      //   celebrityInfo: '',
      //   isNewCoOwnerAddingMode: false,
      // });
    }
  }
  resetCelebrityAfterDelete = () => {
    this.setState({
      celebrityInfo: '',
    });
  }
  handleSaveEventNickName = (eventId, newEventName) => {
    saveEventName(eventId, newEventName, '').then((response) => {
      if (response.body.status.status === 'success') {
        if (document.querySelector('.editEventName')) {
          const box = document.querySelector('.editEventName');
          let winWidth = window.innerWidth;
          box.style.left = winWidth + 'px';
          winWidth += 1;
          box.style.left = winWidth + 'px';
        }
        if (document.querySelector('.editImage')) {
          // document.querySelector('.editImage').removeAttribute('style');
        }
        this.props.handleSaveEventName(newEventName);
      }
    }).catch((e) => {
      console.log(e); // console required
    });
  }
  coOwnerSuccesfullyAddedResponseCallback = (status) => {
    if (status === 'success') {
      this.setState({
        isNewCoOwnerAddingMode: false,
      });
    }
  }
  _eventUpdateResponseCallback = (status) => {
    if (status === 'success') {
      this.setState({
        isEditMode: false,
        celebrityInfo: '',
      });
    }
  }
  _newCoOwnerAddedResponseCallback = (status) => {
    if (status === 'success') {
      this.setState({
        isNewCoOwnerAddingMode: false,
        celebrityInfo: '',
      });
    }
  }
  _handleEditOwnerInformation = (celebrityInfo) => {
    this.setState({
      isEditMode: true,
      celebrityInfo,
      // isrender: !this.state.isrender,
    });
  }
  UNSAFE_componentWillMount() {
    // put the condition if(user.isLoggedIn) then only execute below page otherwise redirect to main landing page.
    const user = this.props.user;
    if (!(user && user.result && user.result.status && user.result.status.status === defaultConst.constAPISuccess)) {
      if (browserHistory) {
        browserHistory.push('/');
      }
    }

    // const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    // if (eventID) {
    //   this._getEventDetails(eventID);
    // }
  }
  componentWillReceiveProps(nextProps) {
    if (!commonUtil.isObjectEmpty(nextProps.userEventDetails) && nextProps.userEventDetails.eventDetailsInfo && this.state.celebrityInfo && nextProps.userEventDetails.eventDetailsInfo.eventId === this.props.userEventDetails.eventDetailsInfo.eventId) {
      nextProps.userEventDetails.eventDetailsInfo.celebrityInfo.forEach((cele) => {
        if (cele.repositoryId === this.state.celebrityInfo.repositoryId && !this.eventChange) {
          this.setState({
            celebrityInfo: cele,
            isAddingAndEditingNewCoOwnerMode: false,
          });
        } else if (cele.repositoryId === this.state.celebrityInfo.repositoryId && this.eventChange) {
          this.eventChange = false;
          this.setState({
            isAddingAndEditingNewCoOwnerMode: false, // mobile
            isEditMode: false,    // desktop
            celebrityInfo: '',
            isNewCoOwnerAddingMode: false,
          });
        }
      });
    }
  }
  _getEventDetails = (eventID) => {
    const user = this.props.user;
    this.props.getEventDetails(eventID, user.result.profileId);
  }

  checkEventEligibleToCreate = () => {
    if (this.props && this.props.user && this.props.user.result.emailId) {
      const emailId = this.props.user && this.props.user.result.emailId;
      loadGiftRegistryCelebrated(emailId).then((response) => {
        if (response.body.status.status === 'success') {
          browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.mesaType));
        } else {
          browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.maxEvents));
        }
      });
    }
  }
  render() {
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    const currentEventStatus = this.props.eventStatus;

    // for Suspended & closed event Status
    let eventStatusForSuspended = false;
    currentEventStatus.map((temp) => {
      if (temp.eventId === eventID) {
        if ([defaultConst.constEventStatus.SUSPENDED, defaultConst.constEventStatus.VALIDITYOFFACTIVE, defaultConst.constEventStatus.CLOSED].indexOf(temp.eventStatus) > -1) {
          eventStatusForSuspended = true;
        }
      } return eventStatusForSuspended;
    });

    // below condition for disble selection tab and checkbox in case of event type Religious Ceremonies
    // const eventCategory = this.props.userEventDetails.eventDetailsInfo.eventCategory;
    const eventType = this.props.userEventDetails.eventDetailsInfo.eventType;
    let selectedEventConfiguration;

    // if (eventCategory === defaultConst.eventCategory.CELEBRATION) {
    /*eslint-disable*/
    const stratConfig = strategy.strategies;
    for (const str in stratConfig) {
      if (stratConfig[str].name === eventType) {
        selectedEventConfiguration = stratConfig[str];
      }
    }
    /*eslint-enable*/
    // }


    const { userEventDetails } = this.props;
    const _eventDetailTemplateHtml =
      (this.state.isEditMode || this.state.isNewCoOwnerAddingMode) ?
        (<EditAdminCelebratedInfo
          celebrityInfo={this.state.celebrityInfo}  // only for editing mode
          handleCancelEditingAndAdding={this.handleCancelEditingAndAdding} // only to cancel editing mode and adding mode
          _newCoOwnerAddedResponseCallback={this._newCoOwnerAddedResponseCallback} // for adding new co owner
          _eventUpdateResponseCallback={this._eventUpdateResponseCallback} // for editing and updating operation
          coOwnerSuccesfullyAddedResponseCallback={this.coOwnerSuccesfullyAddedResponseCallback} // for adding operation
          getEventDetails={this.props.getEventDetails}
          user={this.props.user}
          lables={this.props.lables}
          selectedEventConfiguration={selectedEventConfiguration}
        />) : (<div>
          <ApplyCSS pageName={pageName} />
          <Header
            eventDetailsInfo={userEventDetails.eventDetailsInfo}
            handleSaveEventNickName={this.handleSaveEventNickName}
            _getEventDetails={this._getEventDetails}
            saveEventName={saveEventName}
            {...this.props}
            user={this.props.user}
            checkEventEligibleToCreate={this.checkEventEligibleToCreate}
            eventStatusForSuspended={eventStatusForSuspended}
            lables={this.props.lables}
            handleValidateEventName={handleValidateEventName}
          />
          <div />
          <Body
            eventDetailsInfo={userEventDetails.eventDetailsInfo}
            {...this.props}
            addNewCoOwner={this.addNewCoOwner}
            _handleEditOwnerInformation={this._handleEditOwnerInformation}
            removeCoOwner={removeCoOwner}
            _getEventDetails={this._getEventDetails}
            user={this.props.user}
            eventID={eventID}
            eventStatusForSuspended={eventStatusForSuspended}
            lables={this.props.lables}
            selectedEventConfiguration={selectedEventConfiguration}
          />
        </div>);
    if (userEventDetails && userEventDetails.eventDetailsInfo) {
      return (
        channel === 'WEB' ? _eventDetailTemplateHtml :
        <div>
          <ApplyCSS pageName={pageName} />
          <WapDatosDeMiEvento
            showWapEditingSection={this.showWapEditingSection}
            _newCoOwnerAddedResponseCallback={this._newCoOwnerAddedResponseCallback}
            resetCelebrityAfterDelete={this.resetCelebrityAfterDelete}
            handleCancelEditingAndAdding={this.handleCancelEditingAndAdding}
            isAddingAndEditingNewCoOwnerMode={this.state.isAddingAndEditingNewCoOwnerMode}
            celebrityInfo={this.state.celebrityInfo}
            _handleEditOwnerInformation={this._handleEditOwnerInformation}
            getEventDetails={this.props.getEventDetails}
            eventDetailsInfo={userEventDetails.eventDetailsInfo}
            {...this.props}
            handleSaveEventNickName={this.handleSaveEventNickName}
            removeCoOwner={removeCoOwner}
            _getEventDetails={this._getEventDetails}
            eventID={eventID}
            user={this.props.user}
            checkEventEligibleToCreate={this.checkEventEligibleToCreate}
            userEventDetails={this.props.userEventDetails}
            selectedEventConfiguration={selectedEventConfiguration}
            handleValidateEventName={handleValidateEventName}
            lables={this.props.lables}
            eventStatusForSuspended={eventStatusForSuspended}
          />
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  lables: state.labels.data,
  user: state.user.data,
  userEventDetails: state.eventDetails.userEventDetails,
  celebrityInfoData: state.eventDetails.userEventDetails.eventDetailsInfo.celebrityInfo,
  eventStatus: state.eventDetail.data.eventList,
});

const matchDispatchToProps = dispatch => bindActionCreators({ getEventDetails, handleSaveEventName }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(DatosDeMiEvento);
